export const ProductionEnvironment = {
    itemServiceBaseUrl: "https://item-service.commerce.cimpress.io",
    wholesaleAggregationBaseUrl: "https://merchantorder.commerce.cimpress.io",
    prepressBaseUrl: "https://prepress.documents.cimpress.io",
};
export const IntegrationEnvironment = {
    itemServiceBaseUrl: "https://int-item-service.commerce.cimpress.io",
    wholesaleAggregationBaseUrl: "https://int-merchantorder.commerce.cimpress.io",
    prepressBaseUrl: "https://prepress.documents.cimpress.io",
};
//# sourceMappingURL=environment.js.map